import React, { useEffect, useState, useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { globalConfigContext } from "@context/GlobalConfigContext";
import { setShowLoginSignup } from "@store/config/configActions";
import { Container, Row, Col } from "react-bootstrap";
import ticket from "@assets/pictures/svgs/ticket.svg";
import map from "@assets/pictures/svgs/map.svg";
import settings from "@assets/pictures/svgs/settings.svg";
import popcorn from "@assets/pictures/svgs/popcorn.svg";
import luxuryIcon from "@assets/pictures/diamond-luxury.svg";
import loyaltyIcon from "@assets/pictures/loyaltyIcon.svg";
import sportsicon from "@assets/pictures/Sports Icon.svg";
import fifaIcon from "@assets/pictures/football-logo.png";
import ExperienceIcon from "@assets/pictures/experiences-logo.png";
import OldSchoolClassicIcon from "@assets/pictures/Cinepolis_Movie_Camera_Vector.svg";
import OldSchoolClassicIcon1 from "../../assets/pictures/RetroCinemaCamera.png";


function MenuContainer(props) {
  const { arabic, country_data, site_data } = useContext(globalConfigContext);
  const location = useLocation();
  const history = useHistory();
  const dispatch = useDispatch();

  const user = useSelector((state) => state.user.current_user);
  const currentPage = location.pathname.split("/")[1];
  // console.log(currentPage, "RUCHI");

  const handleShow = () => dispatch(setShowLoginSignup(true));

  const [selectedBottomNavLink, setSelectedBottomNavLink] = useState("home");

  useEffect(() => {
    setSelectedBottomNavLink(
      currentPage
        ? currentPage.replace("/", "") === ""
          ? "home"
          : currentPage.replace("/", "")
        : "home"
    );
  }, [location]);

  if (
    ![
      "/my-profile",
      "movies",
      "tnc",
      "faq",
      "/promotion",
      "",
      "privacy-policy",
      "/cinema",
      "/experiences",
      "/ramadan-film-festival",
      "feedback",
      "search-movie",
      "cinema",
      "my-profile",
      "promotion",
      "experiences",
      "luxury",
      "fifa",
      "FnbDetailsContainer",
      "about-us",
      "ibero-american-film-festival",
      "movies-list",
      "games",
      "sfifa",
      "club-cinepolis",
      "old-school-classics"
    ].includes(currentPage)
  ) {
    return null;
  }

  const handleBottomNav = (dest) => {
    switch (dest) {
      case "home":
        setSelectedBottomNavLink(dest);
        return history.push("/");
      case "fifa":
        setSelectedBottomNavLink(dest);
        return history.push("/games");
      case "movies":
        setSelectedBottomNavLink(dest);
        return history.push("/");
      case "fifa":
        setSelectedBottomNavLink(dest);
        return history.push("/fifa");
      case "promotion":
        setSelectedBottomNavLink(dest);
        return history.push("/promotion");
      case "seatlayout":
        setSelectedBottomNavLink(dest);
        return history.push("/promotion");
      case "seatlayout":
        setSelectedBottomNavLink(dest);
        return history.push("/offers");
      case "experiences":
        setSelectedBottomNavLink(dest);
        if (
          country_data?.country_id === 2 
        ) {
          history.push("/old-school-classics");
        } else {
          // return history.push("/experiences");
          history.push("/old-school-classics");
        }
        break;
      case "luxury":
        setSelectedBottomNavLink(dest);
        return history.push("/luxury");
      case "cinema":
        setSelectedBottomNavLink(dest);
       return  history.push("/cinema");
          case "eruo":
        setSelectedBottomNavLink(dest);
       return  history.push("/european-movies");
         case "club-cinepolis":
        setSelectedBottomNavLink(dest);
        return history.push("/club-cinepolis");
      case "old-school-classics":
        console.log(dest, "thishis deahsdh");
        setSelectedBottomNavLink(dest);
        return history.push("/old-school-classics");
      case "my-profile":
        setSelectedBottomNavLink(dest);
        return history.push("/my-profile");
      case "mexico-film-festival-movies":
        setSelectedBottomNavLink(dest);
        return history.push("/ibero-american-film-festival");
      case "fnb-view":
        setSelectedBottomNavLink(dest);
        return history.push("/fnb-view");

      case "ramadan-film-festival":
        setSelectedBottomNavLink(dest);
        return history.push("/ramadan-film-festival");
      case "games":
        setSelectedBottomNavLink(dest);
        return history.push("/games");
      case "sfifa":
        setSelectedBottomNavLink(dest);
        return history.push("/sfifa");

      // if(!user) {
      //     dispatch(setShowLoginSignup(true));
      // } else {
      //     setSelectedBottomNavLink(dest);
      //     return history.push('/my-profile');
      // }
    }
  };
  return (
    <div className="d-block d-md-none">
      <div className="mobile-menu-floaters">
        <div className="menu">
          <div
            className={`menu-item ${
              selectedBottomNavLink === "home" ||
              selectedBottomNavLink === "tnc" ||
              selectedBottomNavLink === "privacy-policy" ||
              selectedBottomNavLink === "movies"
                ? "active"
                : ""
            }`}
            onClick={() => handleBottomNav("home")}
          >
            {/* <img src={ticket} alt="menu" className="" /> */}

            <svg
              width="1200pt"
              height="1200pt"
              version="1.1"
              viewBox="0 0 1200 1200"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="m1147 483.55-484.45-426.57c-35.672-31.324-89.469-31.324-125.16 0.023437l-484.43 426.55c-21.281 18.742-28.559 48.004-18.543 74.535 10.02 26.531 34.82 43.676 63.18 43.676h89.887v470.07c0 52.199 42.469 94.668 94.66 94.668h133.3c37.289 0 67.621-30.332 67.621-67.621l0.003906-331.7c0-7.668 6.2422-13.91 13.91-13.91h206c7.668 0 13.91 6.2422 13.91 13.91v331.7c0 37.289 30.332 67.621 67.621 67.621h133.3c52.191 0 94.66-42.469 94.66-94.668l0.003906-470.07h89.887c28.359 0 53.16-17.145 63.18-43.676 10.016-26.531 2.7383-55.793-18.551-74.539zm-31.699 55.562c-1.0156 2.6875-4.3086 8.9414-12.93 8.9414h-116.75c-14.832 0-26.855 12.023-26.855 26.855v496.93c0 22.586-18.371 40.953-40.949 40.953h-133.3c-7.668 0-13.91-6.2422-13.91-13.91v-331.7c0-37.289-30.332-67.621-67.621-67.621h-206c-37.289 0-67.621 30.332-67.621 67.621v331.7c0 7.668-6.2422 13.91-13.91 13.91l-133.3-0.003906c-22.578 0-40.949-18.371-40.949-40.953v-496.93c0-14.832-12.023-26.855-26.855-26.855h-116.75c-8.6211 0-11.918-6.2539-12.93-8.9414-1.0156-2.6875-2.6758-9.5547 3.7891-15.254l484.41-426.52c15.453-13.574 38.777-13.574 54.219-0.023438l484.42 426.54c6.4727 5.7031 4.8086 12.57 3.7969 15.258z"
                fill="#fff"
              />
            </svg>
          </div>

          {/* {country_data &&
            (country_data.country_short_code === "AE" ||
            country_data.country_short_code === "OM" ||
            country_data.country_short_code === "BH") &&
            site_data && (
              <div
                className={`menu-item ${
                  selectedBottomNavLink === "fifa" ? "active" : ""
                }`}
                onClick={() => handleBottomNav("fifa")}
              >
                <img height="40px" src={fifaIcon} alt="fifa"/>
              </div>
            )} */}

          {true && (
            <div
              className={`menu-item ${
                selectedBottomNavLink === "promotion" ||
                selectedBottomNavLink === "seatlayout" ||
                selectedBottomNavLink === "offers"
                  ? "active"
                  : ""
              }`}
              onClick={() => handleBottomNav("promotion")}
            >
              {/* <img src={ticket} alt="menu" className="" /> */}

              <svg width="28px" height="28px" viewBox="0 0 28 28" version="1.1">
                <g
                  id="Profile"
                  stroke="none"
                  strokeWidth="1"
                  fill="none"
                  fillRule="evenodd"
                  opacity="1"
                >
                  <g
                    id="np_discount_1570916_000000"
                    fill="#FFFFFF"
                    fillRule="nonzero"
                  >
                    <path
                      d="M14,0 C13.1739285,0 12.5536564,0.437498849 12.0082473,0.805918932 C11.4628383,1.17433901 10.962008,1.49958026 10.6727245,1.5773169 C10.3834411,1.65505354 9.78623214,1.62336941 9.12996545,1.5773169 C8.47369875,1.53126439 7.71530601,1.46362615 7.00005526,1.87665822 C6.28480451,2.28969029 5.96387378,2.97760795 5.67602717,3.5691064 C5.38818056,4.16060484 5.11621285,4.69308239 4.9046292,4.9046292 C4.69304554,5.11617601 4.16060484,5.38818056 3.5691064,5.67602717 C2.97760795,5.96387378 2.28969397,6.28476767 1.87665822,7.00005526 C1.46362246,7.71534285 1.51975126,8.4737356 1.56580377,9.12996545 C1.61185628,9.7861953 1.65503143,10.3834411 1.5773169,10.6727245 C1.49960237,10.962008 1.17433901,11.4628014 0.805918932,12.0082473 C0.437498849,12.5536933 0,13.1739653 0,14 C0,14.8260347 0.437498849,15.4463436 0.805918932,15.9917527 C1.17433901,16.5371617 1.49958026,17.037992 1.5773169,17.3272755 C1.65505354,17.6165589 1.61185628,18.2137679 1.56580377,18.8700346 C1.51975126,19.5263012 1.46362615,20.284694 1.87665822,20.9999447 C2.28969029,21.7151955 2.97760795,22.0361262 3.5691064,22.3239728 C4.16060484,22.6118194 4.69308239,22.8837871 4.9046292,23.0953708 C5.11617601,23.3069545 5.38818056,23.8393952 5.67602717,24.4308936 C5.96387378,25.022392 6.28476767,25.710306 7.00005526,26.1233418 C7.71534285,26.5363775 8.4737356,26.4802487 9.12996545,26.4341962 C9.7861953,26.3881437 10.3834411,26.3449686 10.6727245,26.4226831 C10.962008,26.5003976 11.4628014,26.825661 12.0082473,27.1940811 C12.5536933,27.5625012 13.1739653,28 14,28 C14.8260347,28 15.4463436,27.5625012 15.9917527,27.1940811 C16.5371617,26.825661 17.037992,26.5004197 17.3272755,26.4226831 C17.6165589,26.3449465 18.2137679,26.3881437 18.8700346,26.4341962 C19.5263012,26.4802487 20.284694,26.5363739 20.9999447,26.1233418 C21.7151955,25.7103097 22.0361262,25.022392 22.3239728,24.4308936 C22.6118194,23.8393952 22.8837871,23.3069176 23.0953708,23.0953708 C23.3069545,22.883824 23.8393952,22.6118194 24.4308936,22.3239728 C25.022392,22.0361262 25.710306,21.7152323 26.1233418,20.9999447 C26.5363775,20.2846571 26.4687356,19.5262644 26.4226831,18.8700346 C26.3766306,18.2138047 26.3449686,17.6165589 26.4226831,17.3272755 C26.5003976,17.037992 26.825661,16.5371986 27.1940811,15.9917527 C27.5625012,15.4463067 28,14.8260347 28,14 C28,13.1739653 27.5625012,12.5536564 27.1940811,12.0082473 C26.825661,11.4628383 26.5004197,10.962008 26.4226831,10.6727245 C26.3449465,10.3834411 26.3766306,9.78623214 26.4226831,9.12996545 C26.4687356,8.47369875 26.5363739,7.71530601 26.1233418,7.00005526 C25.7103097,6.28480451 25.022392,5.96387378 24.4308936,5.67602717 C23.8393952,5.38818056 23.3069176,5.11621285 23.0953708,4.9046292 C22.883824,4.69304554 22.6118194,4.16060484 22.3239728,3.5691064 C22.0361262,2.97760795 21.7152323,2.28969397 20.9999447,1.87665822 C20.2846571,1.46362246 19.5262644,1.53126439 18.8700346,1.5773169 C18.2138047,1.62336941 17.6165589,1.65503143 17.3272755,1.5773169 C17.037992,1.49960237 16.5371986,1.17433901 15.9917527,0.805918932 C15.4463067,0.437498849 14.8260347,0 14,0 Z M14,1.47368033 C14.2245078,1.47368033 14.6677614,1.68523451 15.174339,2.02631046 C15.6809166,2.3673864 16.222052,2.81063997 16.9473607,3.00490788 C17.6726693,3.19917579 18.3649306,3.08262241 18.9736711,3.03944726 C19.5824116,2.99627212 20.0688735,3.04232536 20.2631414,3.15457854 C20.4574093,3.26683172 20.7322875,3.66402983 20.9999816,4.21378628 C21.2676756,4.76354273 21.5166171,5.42120942 22.0476946,5.95228697 C22.5787722,6.48336452 23.2364389,6.73230597 23.7861953,7 C24.3359517,7.26769403 24.7331454,7.54257226 24.845403,7.73684017 C24.9576606,7.93110808 25.0037095,8.41756995 24.9605343,9.02631046 C24.9173592,9.63505096 24.8007911,10.3272755 24.9950737,11.0526209 C25.1893563,11.7779664 25.6326247,12.3190649 25.9736711,12.8256426 C26.3147176,13.3322202 26.5263012,13.7754664 26.5263012,13.9999816 C26.5263012,14.2244968 26.3147471,14.667743 25.9736711,15.1743206 C25.6325952,15.6808982 25.1893416,16.2220336 24.9950737,16.9473422 C24.8008058,17.6726509 24.9173592,18.3649122 24.9605343,18.9736527 C25.0037095,19.5823932 24.9562168,20.0688551 24.845403,20.263123 C24.7331491,20.4574056 24.3359517,20.7322691 23.7861953,20.9999632 C23.2364389,21.2676572 22.5787722,21.5165986 22.0476946,22.0476762 C21.5166171,22.5787537 21.2676756,23.2364204 20.9999816,23.7861769 C20.7322875,24.3359333 20.4574093,24.733127 20.2631414,24.8453846 C20.0688735,24.9576422 19.5824116,25.003691 18.9736711,24.9605159 C18.3649306,24.9173407 17.6727061,24.8007726 16.9473607,24.9950553 C16.2220152,25.1893379 15.6809166,25.6326062 15.174339,25.9736527 C14.6677614,26.3146992 14.2245152,26.5262828 14,26.5262828 C13.7754848,26.5262828 13.3322386,26.3147286 12.825661,25.9736527 C12.3190834,25.6325768 11.777948,25.1893232 11.0526393,24.9950553 C10.3273307,24.8007874 9.63506938,24.9173407 9.02632888,24.9605159 C8.41758837,25.003691 7.9311265,24.9561984 7.73685859,24.8453846 C7.54257594,24.7331307 7.26771245,24.3359333 7.00001842,23.7861769 C6.73232439,23.2364204 6.48338294,22.5787537 5.95230539,22.0476762 C5.42122784,21.5165986 4.76356115,21.2676572 4.2138047,20.9999632 C3.66404825,20.7322691 3.26685456,20.4573909 3.15459696,20.263123 C3.04233936,20.0688551 2.99629054,19.5823932 3.03946569,18.9736527 C3.08264084,18.3649122 3.19920895,17.6726877 3.0049263,16.9473422 C2.81064366,16.2219968 2.36737535,15.6808982 2.02632888,15.1743206 C1.68528241,14.667743 1.47369875,14.2244968 1.47369875,13.9999816 C1.47369875,13.7754664 1.68525293,13.3322202 2.02632888,12.8256426 C2.36740482,12.3190649 2.81065839,11.7779295 3.0049263,11.0526209 C3.19919421,10.3273123 3.08264084,9.63505096 3.03946569,9.02631046 C2.99629054,8.41756995 3.04234378,7.93110808 3.15459696,7.73684017 C3.26685014,7.54257226 3.66404825,7.26769403 4.2138047,7 C4.76356115,6.73230597 5.42122784,6.48336452 5.95230539,5.95228697 C6.48338294,5.42120942 6.73232439,4.76354273 7.00001842,4.21378628 C7.26771245,3.66402983 7.54259068,3.26683614 7.73685859,3.15457854 C7.9311265,3.04232094 8.41758837,2.99627212 9.02632888,3.03944726 C9.63506938,3.08262241 10.3272939,3.19919053 11.0526393,3.00490788 C11.7779848,2.81062524 12.3190834,2.36735693 12.825661,2.02631046 C13.3322386,1.68526399 13.7754848,1.47368033 14,1.47368033 Z M19.8026163,7.35698064 C19.639992,7.38000689 19.4903213,7.4562809 19.376649,7.57573006 L7.58720635,19.3651727 C7.4432941,19.5004529 7.36126168,19.6889808 7.35830574,19.8875924 C7.35550622,20.0861929 7.43178097,20.2761651 7.57137534,20.4171963 C7.70953287,20.5582312 7.89949763,20.6373862 8.09810553,20.635965 C8.29670606,20.6345063 8.48524135,20.5539133 8.62339889,20.4128784 L20.4128415,8.62343573 C20.647422,8.40324578 20.7107423,8.05640038 20.571148,7.76571693 C20.4315499,7.47644822 20.1206807,7.31093918 19.8026605,7.35699169 L19.8026163,7.35698064 Z M10.3157992,7.36849377 C8.69677711,7.36849377 7.3684385,8.69683238 7.3684385,10.3158544 C7.3684385,11.9348765 8.69677711,13.2632151 10.3157992,13.2632151 C11.9348212,13.2632151 13.2631598,11.9348765 13.2631598,10.3158544 C13.2631598,8.69683238 11.9348212,7.36849377 10.3157992,7.36849377 Z M10.3157992,8.8421741 C11.138997,8.8421741 11.7894795,9.4926566 11.7894795,10.3158544 C11.7894795,11.1390523 11.138997,11.7895348 10.3157992,11.7895348 C9.49260134,11.7895348 8.84211884,11.1390523 8.84211884,10.3158544 C8.84211884,9.4926566 9.49260134,8.8421741 10.3157992,8.8421741 Z M17.6842008,14.7368954 C16.0651788,14.7368954 14.7368402,16.065234 14.7368402,17.6842561 C14.7368402,19.3032781 16.0651788,20.6316168 17.6842008,20.6316168 C19.3032229,20.6316168 20.6315615,19.3032781 20.6315615,17.6842561 C20.6315615,16.065234 19.3032229,14.7368954 17.6842008,14.7368954 L17.6842008,14.7368954 Z M17.6842008,16.2105758 C18.5073987,16.2105758 19.1578812,16.8610583 19.1578812,17.6842561 C19.1578812,18.5074539 18.5073987,19.1579364 17.6842008,19.1579364 C16.861003,19.1579364 16.2105205,18.5074539 16.2105205,17.6842561 C16.2105205,16.8610583 16.861003,16.2105758 17.6842008,16.2105758 L17.6842008,16.2105758 Z"
                      id="Shape"
                    ></path>
                  </g>
                </g>
              </svg>
            </div>
          )}

          {/* {country_data &&
            country_data.country_short_code === "SA" &&
            site_data &&
            site_data.mexican_ff === "Y" && (
              <div
                className={`menu-item ${
                  selectedBottomNavLink === "mexico-film-festival-movies"
                    ? "active"
                    : ""
                }`}
                onClick={() => handleBottomNav("mexico-film-festival-movies")}
              >
                <svg
                  id="Capa_1"
                  enable-background="new 0 0 512 512"
                  height="512"
                  viewBox="0 0 512 512"
                  width="512"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    id="XMLID_168_"
                    fill="#fff"
                    d="m502.177 93.892-240.971-88.987c-3.36-1.241-7.053-1.241-10.413 0l-240.97 88.987c-5.947 2.729-9.823 7.879-9.823 14.099v385.005c0 8.3 6.729 15.029 15.029 15.029h59.709c8.3 0 15.029-6.729 15.029-15.029 0-10.822-.638-49.153-8.855-88.02-3.911-18.504-8.998-34.344-15.119-47.08-2.479-5.159-5.155-9.854-8.018-14.08 18.897-1.431 36.685-7.298 52.985-17.517 16.094-10.089 30.406-24.184 42.537-41.891 19.193-28.014 28.491-58.077 31.461-80.334h142.48c2.971 22.257 12.268 52.319 31.461 80.334 12.132 17.708 26.443 31.802 42.537 41.891 16.301 10.219 34.088 16.086 52.985 17.517-2.862 4.226-5.538 8.921-8.018 14.08-6.121 12.736-11.208 28.576-15.119 47.08-8.216 38.867-8.855 77.198-8.855 88.02 0 8.3 6.729 15.029 15.029 15.029h59.709c8.3 0 15.029-6.729 15.029-15.029v-385.005c.004-8.366-6.593-12.763-9.819-14.099zm-246.177-58.867 156.887 57.937h-313.774zm-196.612 442.942h-29.329v-121.174c8.749 10.786 16.184 29.51 21.446 54.4 5.36 25.356 7.239 50.558 7.883 66.774zm-29.329-159.064v-114.829h63.391c-3.83 73.72-35.937 101.301-63.391 114.829zm98.442-51.483c-7.601 11.094-18.224 23.29-32.248 32.439 16.451-24.839 25.478-56.644 27.283-95.784h30.823c-3.142 18.448-11.508 42.399-25.858 63.345zm254.998 0c-14.349-20.945-22.715-44.897-25.858-63.345h30.823c1.805 39.141 10.832 70.946 27.283 95.784-14.024-9.149-24.648-21.345-32.248-32.439zm98.442 210.547h-29.329c.643-16.216 2.523-41.418 7.883-66.774 5.261-24.891 12.697-43.615 21.446-54.4zm0-159.064c-27.454-13.528-59.562-41.11-63.391-114.829h63.391zm0-144.887h-451.882v-50.995h451.883v50.995z"
                  />
                </svg>
              </div>
            )} */}

          {country_data &&
          country_data.country_short_code === "OM" &&
          site_data ? (
            <div
              className={`menu-item ${
                selectedBottomNavLink === "club-cinepolis" ? "active" : ""
              }`}
              onClick={() => handleBottomNav("experiences")}
            >
              <img height="38px" src={OldSchoolClassicIcon1} />
            </div>
          ) : (
            <div
              className={`menu-item ${
                selectedBottomNavLink === "experiences" ? "active" : ""
              }`}
              onClick={() => handleBottomNav("experiences")}
            >
                {
                  true
            ? (
              <img height="38px" src={OldSchoolClassicIcon1} />
            ) :
            <img height="38px" src={OldSchoolClassicIcon1} />
            // (<img height="30px" src={ExperienceIcon} alt="experiences" />
            // )
            }
            </div>
          )}


 
           {country_data &&
          country_data.country_short_code === "OM" &&
          site_data ? (
            <div
              className={`menu-item ${
                selectedBottomNavLink === "eruo" ? "active" : ""
              }`}
              onClick={() => handleBottomNav("eruo")}
            >
              <img height="38px" src={OldSchoolClassicIcon1} />
            </div>
          ) : (
            <div
              className={`menu-item ${
                selectedBottomNavLink === "eruo" ? "active" : ""
              }`}
              onClick={() => handleBottomNav("eruo")}
            >
                {
                  true
            ? (
              <img height="38px" src={OldSchoolClassicIcon1} />
            ) :
            <img height="38px" src={OldSchoolClassicIcon1} />
            // (<img height="30px" src={ExperienceIcon} alt="experiences" />
            // )
            }
            </div>
          )}

          {/* <div
            className={`menu-item ${selectedBottomNavLink === "games" ? "active" : ""
              }`}
            onClick={() => handleBottomNav("games")}
          >

            <img height="38px" src={sportsicon} alt="sports" />
          </div> */}

          {country_data &&
            country_data.country_short_code === "SA" &&
            site_data && (
              <div
                className={`menu-item ${
                  selectedBottomNavLink === "luxury" ? "active" : ""
                }`}
                onClick={() => handleBottomNav("luxury")}
              >
                <img height="25px" src={luxuryIcon} alt="luxury" />
              </div>
            )}
         {/* location */}
          {/* <div
            className={`menu-item ${
              selectedBottomNavLink === "cinema" ? "active" : ""
            }`}
            onClick={() => handleBottomNav("cinema")}
          > */}
            {/* {country_data?.country_id == 2 &&
           (user?.email == "rajmit.mistry@enpointe.io" || user?.email == "singh.jaspreet1988@gmail.com" || user?.current_user?.email == "rajmit.mistry@enpointe.io" || user?.current_user?.email == "singh.jaspreet1988@gmail.com") ? (
              <img src={OldSchoolClassicIcon} />
            ) : ( */}
              {/* <svg
                viewBox="0 0 22 29"
                version="1.1"
                xmlns="http://www.w3.org/2000/svg"
              >
                <g
                  id="Homepage"
                  stroke="none"
                  stroke-width="1"
                  fill="none"
                  fill-rule="evenodd"
                  opacity="1"
                >
                  <g
                    id="Homepage-(Mobile-V2)"
                    transform="translate(-227.000000, -763.000000)"
                    fill="#FFFFFF"
                    fill-rule="nonzero"
                  >
                    <g
                      id="Group-11"
                      transform="translate(0.000000, 742.000000)"
                    >
                      <g
                        id="Group-10"
                        transform="translate(18.000000, 16.000000)"
                      >
                        <g
                          id="Group-6"
                          transform="translate(200.000000, 0.000000)"
                        >
                          <g
                            id="np_map_1985127_000000"
                            transform="translate(9.600000, 5.600000)"
                          >
                            <path
                              d="M10.4614054,28.0589838 C10.6972533,28.0589838 10.9342609,27.9702472 11.1152432,27.7916112 C11.5087116,27.4063027 20.7361494,18.2630642 20.7361494,10.3120972 C20.7361494,4.64709676 16.1265553,0.0375026439 10.4615549,0.0375026439 C4.79655438,0.0375026439 0.186960259,4.64709676 0.186960259,10.3120972 C0.186960259,18.2633631 9.41421872,27.4063326 9.80786646,27.7916112 C9.98883981,27.9702501 10.2258444,28.0589838 10.4617043,28.0589838 L10.4614054,28.0589838 Z M2.05491892,10.3119568 C2.05491892,5.67665747 5.82610612,1.90547027 10.4614054,1.90547027 C15.0967047,1.90547027 18.8678919,5.67665747 18.8678919,10.3119568 C18.8678919,16.329656 12.5432251,23.5638673 10.4614054,25.7810875 C8.37964551,23.5638673 2.05491892,16.329656 2.05491892,10.3119568 Z"
                              id="Shape"
                            ></path>
                            <path
                              d="M16.0657297,10.3119568 C16.0657297,7.2213587 13.5519437,4.70763243 10.4614054,4.70763243 C7.37086713,4.70763243 4.85708108,7.22141848 4.85708108,10.3119568 C4.85708108,13.402495 7.37086713,15.9162811 10.4614054,15.9162811 C13.5519437,15.9162811 16.0657297,13.402495 16.0657297,10.3119568 Z M6.72518919,10.3119568 C6.72518919,8.25120934 8.40182369,6.57574054 10.4614054,6.57574054 C12.5209871,6.57574054 14.1976216,8.25120934 14.1976216,10.3119568 C14.1976216,12.3727042 12.5209871,14.048173 10.4614054,14.048173 C8.40182369,14.048173 6.72518919,12.3727042 6.72518919,10.3119568 Z"
                              id="Shape"
                            ></path>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
              </svg> */}
            {/* )} */}
            {/* <img src={map} alt="menu" className="" /> */}
          {/* </div> */}
          {/* {user && } */}
          {!user && (
            <div onClick={handleShow}>
              {/* <img src={settings} alt="menu" className="" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="58"
                viewBox="0 0 56 58"
              >
                <image
                  id="icons8-user-96"
                  width="56"
                  height="58"
                  href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA6CAYAAADlTpoVAAAEsUlEQVRoge2aW4xeUxTHf2M6HRqZVtMSCdqgEl7oNJMY10lIKOJSEpG4RXhyqQgSXoSIB+ISEUFCQhARIiqCaLSNS9BgKlVh3OpBqU5pi1HTmZE1/mdy7Nnn+85l7zPfJ/7Jfji3tdb/7Nu67A7iYS/gaOB4oA9YBMyTtl+B74D1wHvAIDAR0ZbgWALcAXwO/C7jfc2ebQJu1zctj/nAA8BIA1JZ7Q/g/lQvtxwG1BtFibnNev3UUORCzcFzgOeAvTOe21wbArbrer6GZF/G+6PAhcBLgeyrhBUZPWFk7gSWAl0eBXavV+/8kiHj3Jkmdyiww2PYKj3Li8OA1z1ybLVdPJME3/EYdVcFefd65K0LaG8hXOox5uEAcp/0yL24Rl6T6AQ2Okas1+ZeFbOADY7sjdJZG05xDBgHTgyo/HRPLw7USdCdK29H0PGuo+PuMkLKDCkbQsuce6vKKG+Cl53HfdIdHfsDW1J/dkwOdWicoKGf6PlBuguhTA/uCyxMXY8oMgiNb+WfJlgo3dEJdjkr2h5gVwSCu+SyJZiV4RE1RBmCezR0EhjZOWUYNMEcZ86NS3chlCFoMdxw6nof4OAIBA9xftw26S6EMgSHFRkksB7sr0xnOvod+4acH5sLZQjavPjYuXdWCTnN4Mr8yJmTUXGmswmPKiwKhWWSmdaxvC5yhm7gK8eA1QHlv+XI/lo6a8U1Hn+xlDvl4B6P3KvrJof+6KceY26sIPMmj7xPgNkB7S4E31yx9oTyLnnRo29cOaHndilclZFPMffteuCgBkJt/7wW+CZDxpVVjQuVVbM58lDGsx1aNCyl+LPumV95lOLKnozvVgIPBrIvCC4AfgyQF/0JuKiViKVxBPBCBXLPA4e3Dp1sHAc8Kv+xGSkbto/om+CIWV1CK+mxGdWlzcCHwAepjPf/KIrYPYh0dCtYTeK7UcV2uzVMoyoPhSWptkjDcwGwn2LG2SJqhP5SG1FdYpuG6WaFRV/K150xghYDHqn5NSBv40CRCYHt2nLMTVsLvK+y2ljADvHCNufbVC+out8VbWtVNe4NTcrmzXnAGw3KXHnbaIbvWqT9JlvMpqZ50mZD9GzgBuDknD/jC82j7+WRbNX82iliu/Vesuj0aJ5avvMA5WEWy2HIA+vV+4BXcr4/BVsonm3yVy1n+Znq6it0omJuUUUe2F55DHC+ZG/KUfN/psghhjOczLXbBhXYLq1xm+mVzsEGdm3Jk9ZY2UDAGo372lMHKXRrtKxpYOd1WR9fkfHBUIt692bTUIbNl7sv9zuFjqQ9HmhexYLZ9pjH7rG0897lqahOVMyt1I2bPfZvSGoZvqF5SxuRS3Crh8dl9uw15+abLWFuOax2uLyK/L7khnn4p7UhsQTLxSHhMxlnutF1VhKoHTBXHKY4ucWXPyMVM+vCTnGYgkuwo+7zKIHR6XpXvvJZ1Ag7MqbZ7hIcryOojIgxp7w+LZ6ap3NhW2typENiQmHXv04Md6gsXKRQ0k4Y7tS2cNJ/lKAFw5PHkF+cgRxL7GYlhO70PLtEZ0AXaLltt9XUuNgiYxv9U8DTyc00LOw3b8C88HYkaHkfK9f9c8wF+BvQhkoVwP+sogAAAABJRU5ErkJggg=="
                />
              </svg>
            </div>
          )}
          {user && (
            <div
              className={`menu-item ${
                selectedBottomNavLink === "my-profile" ? "active" : ""
              }`}
              onClick={() => handleBottomNav("my-profile")}
            >
              {/* <img src={settings} alt="menu" className="" /> */}
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="56"
                height="58"
                viewBox="0 0 56 58"
              >
                <image
                  id="icons8-user-96"
                  width="56"
                  height="58"
                  href="data:img/png;base64,iVBORw0KGgoAAAANSUhEUgAAADgAAAA6CAYAAADlTpoVAAAEsUlEQVRoge2aW4xeUxTHf2M6HRqZVtMSCdqgEl7oNJMY10lIKOJSEpG4RXhyqQgSXoSIB+ISEUFCQhARIiqCaLSNS9BgKlVh3OpBqU5pi1HTmZE1/mdy7Nnn+85l7zPfJ/7Jfji3tdb/7Nu67A7iYS/gaOB4oA9YBMyTtl+B74D1wHvAIDAR0ZbgWALcAXwO/C7jfc2ebQJu1zctj/nAA8BIA1JZ7Q/g/lQvtxwG1BtFibnNev3UUORCzcFzgOeAvTOe21wbArbrer6GZF/G+6PAhcBLgeyrhBUZPWFk7gSWAl0eBXavV+/8kiHj3Jkmdyiww2PYKj3Li8OA1z1ybLVdPJME3/EYdVcFefd65K0LaG8hXOox5uEAcp/0yL24Rl6T6AQ2Okas1+ZeFbOADY7sjdJZG05xDBgHTgyo/HRPLw7USdCdK29H0PGuo+PuMkLKDCkbQsuce6vKKG+Cl53HfdIdHfsDW1J/dkwOdWicoKGf6PlBuguhTA/uCyxMXY8oMgiNb+WfJlgo3dEJdjkr2h5gVwSCu+SyJZiV4RE1RBmCezR0EhjZOWUYNMEcZ86NS3chlCFoMdxw6nof4OAIBA9xftw26S6EMgSHFRkksB7sr0xnOvod+4acH5sLZQjavPjYuXdWCTnN4Mr8yJmTUXGmswmPKiwKhWWSmdaxvC5yhm7gK8eA1QHlv+XI/lo6a8U1Hn+xlDvl4B6P3KvrJof+6KceY26sIPMmj7xPgNkB7S4E31yx9oTyLnnRo29cOaHndilclZFPMffteuCgBkJt/7wW+CZDxpVVjQuVVbM58lDGsx1aNCyl+LPumV95lOLKnozvVgIPBrIvCC4AfgyQF/0JuKiViKVxBPBCBXLPA4e3Dp1sHAc8Kv+xGSkbto/om+CIWV1CK+mxGdWlzcCHwAepjPf/KIrYPYh0dCtYTeK7UcV2uzVMoyoPhSWptkjDcwGwn2LG2SJqhP5SG1FdYpuG6WaFRV/K150xghYDHqn5NSBv40CRCYHt2nLMTVsLvK+y2ljADvHCNufbVC+out8VbWtVNe4NTcrmzXnAGw3KXHnbaIbvWqT9JlvMpqZ50mZD9GzgBuDknD/jC82j7+WRbNX82iliu/Vesuj0aJ5avvMA5WEWy2HIA+vV+4BXcr4/BVsonm3yVy1n+Znq6it0omJuUUUe2F55DHC+ZG/KUfN/psghhjOczLXbBhXYLq1xm+mVzsEGdm3Jk9ZY2UDAGo372lMHKXRrtKxpYOd1WR9fkfHBUIt692bTUIbNl7sv9zuFjqQ9HmhexYLZ9pjH7rG0897lqahOVMyt1I2bPfZvSGoZvqF5SxuRS3Crh8dl9uw15+abLWFuOax2uLyK/L7khnn4p7UhsQTLxSHhMxlnutF1VhKoHTBXHKY4ucWXPyMVM+vCTnGYgkuwo+7zKIHR6XpXvvJZ1Ag7MqbZ7hIcryOojIgxp7w+LZ6ap3NhW2typENiQmHXv04Md6gsXKRQ0k4Y7tS2cNJ/lKAFw5PHkF+cgRxL7GYlhO70PLtEZ0AXaLltt9XUuNgiYxv9U8DTyc00LOw3b8C88HYkaHkfK9f9c8wF+BvQhkoVwP+sogAAAABJRU5ErkJggg=="
                />
              </svg>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default MenuContainer;
